import { configureStore } from "@reduxjs/toolkit";
import { countryApi } from "api/countryApi";
import { userRoleApi } from "api/userManagementApi";
import { authApi } from "../api/authApi";
import authReducer from "./authSlice";
import countrySlice from "./countrySlice";
import { subscriptionApi } from "api/subscriptionApi";
import { requestApi } from "api/requestApi";
import { externalApi } from 'api/config/externalApi';
import { dashboardApi } from "api/dashboardApi";
import { productUpdateApi } from "api/productUpdateApi";
import { activityLogApi } from "api/activityLogApi";
import { waitlistApi } from "api/waitlistApi";
import { enterprisePlanApi, externalEnterprise, tenantApi } from "api/enterprisePlanApi";
import { walletApi } from "api/walletApi";
import { persistStore, persistReducer } from "redux-persist";
import liveChatApi from "api/live-socket/live-socket-interceptor";
import { ruleEngineApi } from "api/ruleEngineApi";

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

const store = configureStore({
  reducer: {
    auth: authReducer,
    country: countrySlice,
    [authApi.reducerPath]: authApi.reducer,
    [userRoleApi.reducerPath]: userRoleApi.reducer,
    [ruleEngineApi.reducerPath]: ruleEngineApi.reducer,
    [subscriptionApi.reducerPath]: subscriptionApi.reducer,
    [countryApi.reducerPath]: countryApi.reducer,
    [requestApi.reducerPath]: requestApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [externalApi.reducerPath]: externalApi.reducer, 
    [productUpdateApi.reducerPath]: productUpdateApi.reducer,
    [activityLogApi.reducerPath]: activityLogApi.reducer,
    [waitlistApi.reducerPath]: waitlistApi.reducer,
    [enterprisePlanApi.reducerPath]: enterprisePlanApi.reducer,
    [externalEnterprise.reducerPath]: externalEnterprise.reducer,
    [tenantApi.reducerPath]: tenantApi.reducer,
    [walletApi.reducerPath]: walletApi.reducer,
    [liveChatApi.reducerPath]: liveChatApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      userRoleApi.middleware,
      ruleEngineApi.middleware,
      externalApi.middleware,
      subscriptionApi.middleware,
      countryApi.middleware,
      requestApi.middleware,
      dashboardApi.middleware,
      productUpdateApi.middleware,
      activityLogApi.middleware,
      waitlistApi.middleware,
      enterprisePlanApi.middleware,
      externalEnterprise.middleware,
      tenantApi.middleware,
      walletApi.middleware,
      liveChatApi.middleware
    ),
  // Add other store configuration options as needed
});

export { store };

// import { configureStore } from '@reduxjs/toolkit';
// import { countryApi } from 'api/countryApi';
// import { userRoleApi } from 'api/userManagementApi';
// import { authApi } from '../api/authApi';
// import { subscriptionApi } from 'api/subscriptionApi';
// import { requestApi } from 'api/requestApi';
// import { dashboardApi } from 'api/dashboardApi';
// import { productUpdateApi } from 'api/productUpdateApi';
// import { activityLogApi } from 'api/activityLogApi';
// import { waitlistApi } from 'api/waitlistApi';
// import { enterprisePlanApi } from 'api/enterprisePlanApi';
// import { walletApi } from 'api/walletApi';
// import { persistStore, persistReducer } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';
// import { combineReducers } from 'redux';
// import { reducers } from './persisted-reducers';

// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;

// const persistConfig = {
//   key: 'root',
//   storage,
//   serializableCheck: true, // Add this to ensure serializable data
// };

// // Combine the reducers
// const combinedReducers = combineReducers(reducers);

// // Persist the combined reducers
// const persistedReducer = persistReducer(persistConfig, combinedReducers);

// const store = configureStore({
//   reducer: persistedReducer,
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: {
//         ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
//       },
//     }).concat(
//       authApi.middleware,
//       userRoleApi.middleware,
//       subscriptionApi.middleware,
//       countryApi.middleware,
//       requestApi.middleware,
//       dashboardApi.middleware,
//       productUpdateApi.middleware,
//       activityLogApi.middleware,
//       waitlistApi.middleware,
//       enterprisePlanApi.middleware,
//       walletApi.middleware
//     ),
//   // Add other store configuration options as needed
// });

// const persistor = persistStore(store);

// export { store, persistor };
